import type { IsBillingAddressSameAsShippingFieldValue } from "@jti/commerce-types";
import type { Translate } from "@jti/ui";

import type { FormFieldConfig, FormFieldFactory } from "@checkout-v2/formFields/types";

type IsBillingAddressSameAsShippingFieldOption = {
  value: boolean;
  label: string;
};

export type IsBillingAddressSameAsShippingFieldConfig = FormFieldConfig<
  "isBillingAddressSameAsShipping",
  { options: IsBillingAddressSameAsShippingFieldOption[] }
>;

export const isBillingAddressSameAsShippingFieldFactory: FormFieldFactory<
  "isBillingAddressSameAsShipping",
  IsBillingAddressSameAsShippingFieldValue,
  [Translate],
  [{ isAtHomeDelivery: boolean }],
  IsBillingAddressSameAsShippingFieldConfig
> = {
  getDerivedConfig: (translate) => ({
    name: "isBillingAddressSameAsShipping",
    options: [
      { value: true, label: translate("cart.billing.option.address.use_shipping") },
      { value: false, label: translate("cart.billing.option.address.use_different") },
    ],
  }),
  getDefaultValue: ({ isAtHomeDelivery }) => {
    return isAtHomeDelivery;
  },
};
